import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { TransportPlannerProfileListFacade } from './transport-planner-profile-list.facade';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class TransportPlannerProfileListGuard {
  constructor(private transportPlannerProfileListFacade: TransportPlannerProfileListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.transportPlannerProfileListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.transportPlannerProfileListFacade);
  }
}
